module.exports = __webpack_public_path__ + "media/images/mobile/home/LOGO-8fe9c2a93d67869a99fa10fb4ddb672a.png";